<template>
  <div class="about-page">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="container">
        <h1>关于我们</h1>
        <div class="breadcrumb">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>关于我们</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
    </div>

    <div class="container">
      <!-- 关于我们内容部分 -->
      <div class="about-content" id="abouttop">
        <el-tabs v-model="activeTab" tab-position="left" style="min-height: 500px;" @tab-click="handleTabClick">
          <el-tab-pane label="公司简介" name="introduction">
            <div class="tab-content" id="introduction">
              <div class="introduction-content">
                <div class="intro-image2">
                  <img src="/img/007.jpeg" alt="公司简介" style=" object-fit: cover;">
                </div>
                <div class="intro-text">
                  <h2>公司简介</h2>
                  <p>河南正略智研工程咨询有限公司是一家专注于信息化项目造价咨询的企业，公司拥有专业、强大的技术团队，包括软件工程造价师、信息系统审计师、信息系统监理师、注册造价工程师、咨询工程师（投资类）、软件开发工程师等，并拥有多名高级工程师、中级工程师，为政府部门、国有企业、事业单位、中国人民解放军、上市公司等众多客户长期提供专业的咨询服务。
                  </p>
                  <p>公司办公地址分别位于郑州市金水区爱特中心和洛阳市西工区数码大厦，两座城市双引擎办公，为客户提供更加专业的服务。</p>
                  <div class="company-info">
                    <div class="info-item">
                      <h4>创立时间</h4>
                      <p>2022年</p>
                    </div>
                    <div class="info-item">
                      <h4>员工人数</h4>
                      <p>100+</p>
                    </div>
                    <div class="info-item">
                      <h4>服务客户</h4>
                      <p>1000+</p>
                    </div>
                    <div class="info-item">
                      <h4>覆盖城市</h4>
                      <p>20+</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="企业文化" name="culture">
            <div class="tab-content" id="culture">
              <div class="culture-content">
                <h2>企业文化</h2>
                <div class="culture-items">
                  <div class="culture-item">
                    <div class="culture-icon">
                      <i class="el-icon-s-flag"></i>
                    </div>
                    <div class="culture-details">
                      <h3>企业使命</h3>
                      <p>推动工程造价数字化技术创新，为客户创造价值</p>
                    </div>
                  </div>
                  <div class="culture-item">
                    <div class="culture-icon">
                      <i class="el-icon-view"></i>
                    </div>
                    <div class="culture-details">
                      <h3>企业愿景</h3>
                      <p>成为工程造价咨询领域的创新引领者</p>
                    </div>
                  </div>
                  <div class="culture-item">
                    <div class="culture-icon">
                      <i class="el-icon-trophy"></i>
                    </div>
                    <div class="culture-details">
                      <h3>核心价值观</h3>
                      <p>创新、品质、诚信、合作、客户至上</p>
                    </div>
                  </div>
                </div>
                <div class="culture-philosophy">
                  <h3>企业理念</h3>
                  <div class="philosophy-items">
                    <div class="philosophy-item">
                      <h4>创新</h4>
                      <p>不断追求技术创新，推动产品和服务的升级</p>
                    </div>
                    <div class="philosophy-item">
                      <h4>品质</h4>
                      <p>坚持高品质标准，提供可靠的产品和服务</p>
                    </div>
                    <div class="philosophy-item">
                      <h4>诚信</h4>
                      <p>诚实守信，与客户、合作伙伴建立长期互信关系</p>
                    </div>
                    <div class="philosophy-item">
                      <h4>合作</h4>
                      <p>团队协作，共同创造价值</p>
                    </div>
                    <div class="philosophy-item">
                      <h4>客户至上</h4>
                      <p>以客户需求为中心，提供优质的产品和服务</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="技术实力" name="introduction2">
            <div class="tab-content" id="introduction2">
              <div class="introduction-content">
                <div class="intro-text">
                  <h2>技术实力</h2>
                  <p>河南正略智研工程咨询有限公司子公司河南鲲软数字科技有限公司，专业从事定制化软件开发业务，取得了多项软件产品的《软件著作权证书》，并打造了助力造价咨询企业数字化管理转型的专业数字管理平台---“云·咨询数智管理平台”，帮助造价咨询企业解决咨询项目管理混乱、多部门数据不同步、电子档案遗失等管理难题，受到了造价咨询企业的一致好评。</p>
                </div>
              </div>
              <div class="intro-image">
                <img src="/img/032.png" alt="技术实力" >
                <img src="/img/033.png" alt="技术实力" >
                <img src="/img/034.png" alt="技术实力" >
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="发展历程" name="history">
            <div class="tab-content" id="history">
              <h2>发展历程</h2>
              <div class="history-timeline">
                <el-timeline>
                  <el-timeline-item timestamp="2022年" placement="top" color="#1ebec8">
                    <div class="timeline-content">
                      <h3>公司成立</h3>
                      <p>正略智研工程造价咨询有限公司在洛阳成立，专注于工程造价管理系统解决方案</p>
                    </div>
                  </el-timeline-item>
                  <el-timeline-item timestamp="2023年" placement="top" color="#1ebec8">
                    <div class="timeline-content">
                      <h3>产品线扩展</h3>
                      <p>造价咨询业务、工程咨询业务、鲲软科技成立、信息化事业部成立</p>
                    </div>
                  </el-timeline-item>
                  <el-timeline-item timestamp="2024年" placement="top" color="#1ebec8">
                    <div class="timeline-content">
                      <h3>规模拓展</h3>
                      <p>成立软件工程造价团队、成立信息化项目监理团队、洛阳市建设工程造价管协会副会长单位、北京软件造价评估技术创新联盟会员单位</p>
                    </div>
                  </el-timeline-item>
                  <el-timeline-item timestamp="2025年" placement="top" color="#1ebec8">
                    <div class="timeline-content">
                      <h3>技术创新</h3>
                      <p>成为“华为云”经销商、成立AI智能体研究小组、组织《软件工程造价师》培训、河南省软件服务业协会理事单位</p>
                    </div>
                  </el-timeline-item>
                </el-timeline>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="资质荣誉" name="honors">
            <div class="tab-content" id="honors">
              <h2>资质荣誉</h2>
              <div class="honors-list">
                <el-row :gutter="30">
                  <el-col :xs="24" :sm="12" :md="8" v-for="(honor, index) in honors" :key="index">
                    <div class="honor-card">
                      <div class="honor-img" >
                        <img style="height: 450px;" :src="honor.image" :alt="honor.title">
                      </div>
                      <div class="honor-info">
                        <h3>{{ honor.title }}</h3>
                        <p>{{ honor.year }}</p>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="公司剪影" name="team">
            <div class="tab-content" id="honors2">
              <h2>公司剪影</h2>
              <div class="honors-list">
                <el-row :gutter="30">
                  <el-col :xs="24" :sm="12" :md="8" v-for="(honor, index) in honors2" :key="index">
                    <div class="honor-card">
                      <div class="honor-img2">
                        <img :src="honor.image" :alt="honor.title">
                      </div>
                      <div class="honor-info">
                        <h3>{{ honor.title }}</h3>
                        <p>{{ honor.year }}</p>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  data() {
    return {
      activeTab: 'introduction',
      honors: [
        {
          title: '团体标准参编证书',
          // year: '2024年',
          image: '/qyzp/16.jpg' // 1x1 透明图片
        },
        {
          title: '团体标准参编单位证书',
          // year: '2024年',
          image: '/gcal/9.jpg' // 1x1 透明图片
        },
        {
          title: '团体标准参编单位证书',
          // year: '2024年',
          image: '/gcal/10.jpg' // 1x1 透明图片
        },
        {
          title: '企业信用等级证书',
          // year: '2024年',
          image: '/img/020.jpg' // 1x1 透明图片
        },
        {
          title: '环境管理体系认证',
          // year: '2025年',
          image: '/img/021.png' // 1x1 透明图片
        },
        {
          title: '质量管理体系认证',
          // year: '2025年',
          image: '/img/022.png' // 1x1 透明图片
        },
        {
          title: '安全管理体系认证',
          // year: '2025年',
          image: '/img/023.png' // 1x1 透明图片
        },
        {
          title: '华为云经销商认证',
          // year: '2025年',
          image: '/img/024.png' // 1x1 透明图片
        },
        {
          title: '造价师培训授权',
          // year: '2025年',
          image: '/img/025.png' // 1x1 透明图片
        }
      ],
      honors2: [
        {
          title: '软件公司成立',
          // year: '2023年',
          image: '/img/026.png' // 1x1 透明图片
        },
        {
          title: '赴河北学习',
          // year: '2024年',
          image: '/img/027.png' // 1x1 透明图片
        },
        {
          title: '公司组织学习',
          // year: '2024年',
          image: '/img/028.png' // 1x1 透明图片
        },
        {
          title: '公司年会',
          // year: '2025年',
          image: '/img/029.png' // 1x1 透明图片
        },
        {
          title: '公司年会烟花秀',
          // year: '2025年',
          image: '/img/030.png' // 1x1 透明图片
        },
        {
          title: 'deepseek学习',
          // year: '2025年',
          image: '/img/031.png' // 1x1 透明图片
        }
      ],
      departments: [
        { name: '研发部', description: '负责产品研发和技术创新，包括硬件设计、软件开发、测试等工作', icon: 'el-icon-s-opportunity' },
        { name: '销售部', description: '负责产品销售和市场推广，开发新客户并维护现有客户关系', icon: 'el-icon-s-goods' },
        { name: '技术支持部', description: '为客户提供技术咨询、产品培训、故障诊断等服务', icon: 'el-icon-s-help' },
        { name: '生产部', description: '负责产品生产、质量控制、供应链管理等工作', icon: 'el-icon-s-cooperation' },
        { name: '市场部', description: '负责市场调研、品牌推广、展会活动等工作', icon: 'el-icon-data-line' },
        { name: '行政人事部', description: '负责公司行政、人力资源、培训等工作', icon: 'el-icon-s-custom' }
      ],
      leaders: [
        {
          name: '张总经理',
          title: '创始人兼CEO',
          description: '拥有20年工程造价咨询行业经验，曾在多家知名企业担任高管职位。',
          image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=' // 1x1 透明图片
        },
        {
          name: '李工程师',
          title: '技术总监',
          description: '造价管理专家，拥有多项软件专利，曾主导多个大型工程造价项目。',
          image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=' // 1x1 透明图片
        },
        {
          name: '王博士',
          title: '研发总监',
          description: '博士学位，专注于工程造价数据分析和信息化技术研发，行业知名专家。',
          image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=' // 1x1 透明图片
        },
        {
          name: '刘经理',
          title: '市场总监',
          description: '拥有丰富的市场营销经验，精通工程造价咨询行业市场策略。',
          image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=' // 1x1 透明图片
        }
      ]
    }
  },
  created() {
    // 根据路由参数设置当前选中的标签
    this.handleRouteChange()
  },
  watch: {
    // 监听路由变化，处理标签切换
    '$route.query.tab': {
      handler() {
        this.handleRouteChange()
      },
      immediate: true
    }
  },
  methods: {
    // 处理路由变化
    handleRouteChange() {
      const tab = this.$route.query.tab
      if (tab) {
        this.activeTab = tab
        // 使用 nextTick 确保 DOM 已更新
        this.$nextTick(() => {
          this.scrollToSection(tab, false)
        })
      }
    },
    // 处理标签页点击事件
    handleTabClick(tab) {
      // 更新路由查询参数
      this.$router.push({
        path: '/about',
        query: { tab: tab.name }
      }).catch(() => {})
      this.scrollToSection(tab.name)
    },
    // 滚动到指定部分
    scrollToSection(sectionId, updateTab = true) {
      if (updateTab) {
        this.activeTab = sectionId
      }
      
      this.$nextTick(() => {
        const element = document.getElementById(sectionId)
        if (element) {
          // 使用平滑滚动效果
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.about-page {
  padding-bottom: 60px;
}

.tab-content {
  padding: 0 20px;
  
  h2 {
    font-size: 24px;
    margin-bottom: 30px;
    color: #333;
    position: relative;
    padding-bottom: 10px;
    
    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 40px;
      height: 3px;
      background-color: #1ebec8;
    }
  }
}

// 公司简介样式
.introduction-content {
  display: flex;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
  

  .intro-text {
    width: 100%;
    
    @media (max-width: 768px) {
      width: 100%;
    }
    
    p {
      color: #666;
      line-height: 1.8;
      margin-bottom: 15px;
    }
    
    .company-info {
      display: flex;
      flex-wrap: wrap;
      margin-top: 30px;
      background-color: #f5f5f5;
      padding: 20px;
      border-radius: 4px;
      
      .info-item {
        width: 25%;
        text-align: center;
        
        @media (max-width: 576px) {
          width: 50%;
          margin-bottom: 20px;
        }
        
        h4 {
          font-size: 14px;
          color: #666;
          margin-bottom: 5px;
        }
        
        p {
          font-size: 24px;
          color: #1ebec8;
          font-weight: bold;
          margin-bottom: 0;
        }
      }
    }
  }
}
 .intro-image {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;      
      @media (max-width: 768px) {
        flex-direction: column;
        width: 100% ;
        padding-right: 0;
        margin-top: 8px;
        margin-bottom: 20px;
      }
      
      img {
        border-radius: 4px;
        width: 32%;
        height: 450px;
        object-fit: cover;
        @media (max-width: 768px) {
          width: 100%;
          padding-left: 0 ;
          margin-bottom: 20px;
          height: auto ;
        }
      }
  }
  .intro-image2 {
    width: 100%;  
    height: auto;    
    margin-right: 20px;
      @media (max-width: 768px) {
        flex-direction: column;
        width: 100% ;
        padding-right: 0;
        margin-bottom: 20px;
      }
      img {
        border-radius: 4px;
        width: 100%;
        height: 400px;
        object-fit: cover;
        @media (max-width: 768px) {
          width: 100%;
          padding-left: 0 ;
          margin-bottom: 10px;
          height: 200px ;
        }
      }
  }

// 企业文化样式
.culture-content {
  .culture-items {
    margin-bottom: 40px;
    
    .culture-item {
      display: flex;
      align-items: center;
      margin-bottom: 30px;
      background-color: #f5f5f5;
      padding: 20px;
      border-radius: 4px;
      transition: all 0.3s;
      
      @media (max-width: 868px) {
        padding: 8px;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
      }
      &:hover {
        background-color: #e8f4fd;
      }
      
      .culture-icon {
        width: 60px;
        height: 60px;
        background-color: #1ebec8;
        color: #fff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        @media (max-width: 868px) {
          width: 60px;
          height: 45px;
          margin-right: 10px;
        }
        i {
          font-size: 30px;
        }
      }
      
      .culture-details {
        h3 {
          font-size: 18px;
          margin-bottom: 10px;
          color: #333;
          @media (max-width: 868px) {
            margin-bottom: 5px;
          }
        }
        
        p {
          color: #666;
          margin-bottom: 0;
        }
      }
    }
  }
  
  .culture-philosophy {
    h3 {
      font-size: 20px;
      margin-bottom: 20px;
      color: #333;
      @media (max-width: 868px) {
        margin-bottom: 5px;
      }
    }
    
    .philosophy-items {
      display: flex;
      flex-wrap: wrap;
      
      .philosophy-item {
        width: 33.333%;
        padding: 15px;
        
        @media (max-width: 768px) {
          width: 50%;
          padding: 5px;
        }
        
        @media (max-width: 576px) {
          width: 100%;
        }
        
        h4 {
          font-size: 16px;
          margin-bottom: 10px;
          color: #1ebec8;
        }
        
        p {
          color: #666;
          line-height: 1.6;
        }
      }
    }
  }
}

// 发展历程样式
.history-timeline {
  padding: 20px 0;
  
  .timeline-content {
    h3 {
      font-size: 18px;
      margin-bottom: 10px;
      color: #333;
    }
    
    p {
      color: #666;
    }
  }
}

// 资质荣誉样式
.honors-list {
  .honor-card {
    margin-bottom: 30px;
    transition: all 0.3s;
    
    &:hover {
      transform: translateY(-5px);
    }
    
    .honor-img {
      border: 1px solid #eee;
      border-radius: 4px;
      overflow: hidden;
      
      img {
        width: 100%;
        height: 200px;
        
        @media (max-width: 768px) {
          height: 330px !important;
        }
      }
    }
    .honor-img2 {
      border: 1px solid #eee;
      border-radius: 4px;
      overflow: hidden;
      
      img {
        width: 100%;
        height: 200px;
        
        @media (max-width: 768px) {
          height: 160px;
        }
      }
    }
    
    .honor-info {
      padding: 15px 0;
      text-align: center;
      
      h3 {
        font-size: 16px;
        margin-bottom: 5px;
        color: #333;
      }
      
      p {
        color: #999;
        font-size: 14px;
      }
    }
  }
}

// 企业团队样式
.team-intro {
  margin-bottom: 30px;
  
  p {
    color: #666;
    line-height: 1.8;
  }
}

.team-structure,
.team-leaders {
  margin-bottom: 40px;
  
  h3 {
    font-size: 20px;
    margin-bottom: 20px;
    color: #333;
    position: relative;
    padding-bottom: 10px;
    
    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 30px;
      height: 2px;
      background-color: #1ebec8;
    }
  }
}

.department-card {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  background-color: #f5f5f5;
  padding: 15px;
  border-radius: 4px;
  transition: all 0.3s;
  
  &:hover {
    background-color: #e8f4fd;
  }
  
  .department-icon {
    width: 50px;
    height: 50px;
    background-color: #1ebec8;
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    
    i {
      font-size: 24px;
    }
  }
  
  .department-info {
    h4 {
      font-size: 16px;
      margin-bottom: 5px;
      color: #333;
    }
    
    p {
      color: #666;
      font-size: 14px;
      margin-bottom: 0;
    }
  }
}
.page-header {
  background-image: url('/img/bg2.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 40px 0;
  color: #fff;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    z-index: 1;
  }

  .container {
    position: relative;
    z-index: 2;
  }

  h1 {
    margin: 0;
    font-size: 32px;
    font-weight: 500;
    color: #fff;
  }

  .breadcrumb {
    margin-top: 10px;

    .el-breadcrumb {
      font-size: 14px;

      .el-breadcrumb__item {
        .el-breadcrumb__inner {
          color: rgba(255, 255, 255, 0.8);

          &:hover {
            color: #fff;
          }
        }

        &:last-child {
          .el-breadcrumb__inner {
            color: #fff;
          }
        }
      }
    }
  }
}
.leader-card {
  margin-bottom: 30px;
  text-align: center;
  
  .leader-avatar {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    overflow: hidden;
    margin: 0 auto 15px;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  
  .leader-info {
    h4 {
      font-size: 18px;
      margin-bottom: 5px;
      color: #333;
    }
    
    .leader-title {
      color: #1ebec8;
      font-size: 14px;
      margin-bottom: 10px;
    }
    
    .leader-desc {
      color: #666;
      font-size: 14px;
      line-height: 1.6;
    }
  }
}
</style>